@file:OptIn(InternalResourceApi::class)

package asc_app.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/asc_app.composeapp.generated.resources/"

internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

internal val Res.drawable.logo_asc: DrawableResource by lazy {
      DrawableResource("drawable:logo_asc", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_asc.jpg", -1, -1),
      ))
    }

internal val Res.drawable.logout: DrawableResource by lazy {
      DrawableResource("drawable:logout", setOf(
        ResourceItem(setOf(), "${MD}drawable/logout.png", -1, -1),
      ))
    }

internal val Res.drawable.manage_account: DrawableResource by lazy {
      DrawableResource("drawable:manage_account", setOf(
        ResourceItem(setOf(), "${MD}drawable/manage_account.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("logo_asc", Res.drawable.logo_asc)
  map.put("logout", Res.drawable.logout)
  map.put("manage_account", Res.drawable.manage_account)
}
